import { Box, Button, Modal, Grid, SelectChangeEvent, Typography, TextField, Select, MenuItem } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";

import { fetchAddressById, addAddress, updateAddress } from '../../store/addressStore/addressThunk';
import { fetchCountries } from '../../store/countryStore/countryThunk';
import CustomTextField from '../FormFields/CustomTextField';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { IAddressFormInputs } from '../../utils/address.types';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { ApiStatus } from '../../utils/api.types';
import LoadingButton from '@mui/lab/LoadingButton';
import { fetchStates } from '../../store/stateStore/stateThunk';
import { Utils } from '../../utils/common-utils';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 650,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  padding: 0
};

interface DialogAddressFormProps {
  title?: string;
  addressId?: string;
  open: boolean;
  onClose: (k: any) => void;
  counterPartyFlag?: boolean;
  counterPartyId?: string;
}

const DialogAddressForm: FC<DialogAddressFormProps> = ({ title, onClose, addressId, counterPartyId, counterPartyFlag, open, children }) => {

  const dispatch = useAppDispatch();
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const params = useParams();
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [addressType, setAddressType] = useState('');
  const [addressCountry, setAddressCountry] = useState('');
  const [addressState, setAddressState] = useState('');
  const [addressTypes, setAddressTypes] = useState<IOptions[]>([]);
  const [addressData, setAddressData] = useState();

  // Schema to validate account form.
  const schema = yup.object().shape({
    type: yup.string().required("Address type is required."),
    country: yup.string().required("Country is required."),
    state: yup.string().required("State is required."),
    city: yup.string().required("City is required.")
  });
  //form
  const methods = useForm<IAddressFormInputs>({ mode: 'onTouched', resolver: yupResolver(schema) });

  const { status } = useAppSelector(state => state.addresses);

  useEffect(() => {
    const getAddressDetails = async () => {
      if (addressId) {
        const bd: any = await dispatch(fetchAddressById(addressId));

        setAddressData(bd.payload);
        setAddressType(bd.payload.type);

        methods.setValue('type', bd.payload.type);
        methods.setValue('line1', bd.payload.line1);
        methods.setValue('line2', bd.payload.line2);
        methods.setValue('line3', bd.payload.line3);
        methods.setValue('city', bd.payload.city);
        methods.setValue('state', bd.payload.state?._id || '');
        methods.setValue('country', bd.payload.country?._id);
        methods.setValue('code', bd.payload.code);
        methods.setValue('phone1', bd.payload.phone1);
        methods.setValue('phone2', bd.payload.phone2);
        methods.setValue('title', bd.payload.title || '');
        methods.setValue('latitude', bd.payload.latitude ?? '');
        methods.setValue('longitude', bd.payload.longitude ?? '');
        methods.setValue('radius', bd.payload.radius ?? '');
        setAddressCountry(bd.payload.country?._id);
        setAddressState(bd.payload.state?._id);
      }
    }

    getAddressDetails();
  }, [addressId, dispatch, methods]);

  useEffect(() => {
    const getCountries = async () => {
      if (!countryOptions.length) {
        const data: any = await dispatch(fetchCountries());

        setCountryOptions(data.payload.map((c: any) => {
          return { label: c.name, value: c._id }
        }));
      }
    }
    const getStateOptions = async () => {
      if (!stateOptions.length) {
        const stateData: any = await dispatch(fetchStates());
        setStateOptions(stateData.payload.map((c: any) => {
          return { label: c.name, value: c._id }
        }));
      }
    }

    if (open) {
      getCountries();
      getStateOptions();
    }

    setAddressTypes([{
      label: 'Registered',
      value: 'Registered'
    }, {
      label: 'Office',
      value: 'Office'
    }, {
      label: 'Billing',
      value: 'Billing'
    }, {
      label: 'Shipping',
      value: 'Shipping'
    }, {
      label: 'User Address',
      value: 'User-Address'
    }, {
      label: 'Misc',
      value: 'Misc'
    }])
  }, [open, dispatch, countryOptions]);

  const updateAddressDetails = async (e: any) => {
    if (addressId) {
      e.city = Utils.capitalizeFirstLetter(e.city);
      const resData: any = await dispatch(updateAddress({
        addressPayload: e,
        id: addressId
      }));

      if (!resData.error) {
        onClose(true);
      }
    }
  }

  const createAddressDetails = async (e: any) => {
    console.log(counterPartyFlag);
    console.log(counterPartyId);
    console.log("first ---- ", e.city);
    e.city = Utils.capitalizeFirstLetter(e.city);
    console.log("After change", e.city);

    if (counterPartyFlag && counterPartyId != '') {
      const resData: any = await dispatch(addAddress({ ...e, ...{ account: selectedAccount._id, counterPartyId: counterPartyId, counterPartyFlag: counterPartyFlag } }));
      if (!resData.error) {
        onClose(true);
      }
    } else {
      const resData: any = await dispatch(addAddress({ ...e, ...{ account: selectedAccount._id } }));
      if (!resData.error) {
        onClose(true);
      }
    }
  }

  const onSubmit = (e: any) => {
    if (addressId) {
      updateAddressDetails(e);
      return;
    }

    createAddressDetails(e);
  }

  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
    >
      <FormProvider {...methods}>
        {(!addressId || (addressId && addressData)) &&
          <Box sx={style} component="form" onSubmit={methods.handleSubmit(onSubmit)} noValidate>
            <Grid container >
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                <div style={{ float: 'right', marginTop: -7, marginRight: -5 }}>
                  <LoadingButton
                    type="submit"
                    name={'submit'}
                    loading={status === ApiStatus.LOADING}
                    style={{ color: '#488dff', backgroundColor: '#fff', border: '1px solid #488dff', marginRight: 10 }}
                    variant="contained"
                    size='small'>
                    Save
                  </LoadingButton>

                  <Button
                    style={{ color: '#488dff', backgroundColor: '#fff', border: '1px solid #488dff', marginRight: 10 }}
                    variant="contained"
                    size='small'
                    onClick={() => {
                      methods.reset();
                      onClose(false);
                    }} >
                    Cancel
                  </Button>
                </div>
                <h3 style={{ marginTop: -2 }}>{addressId ? 'Address Update' : 'Add Address Details'}</h3>
              </Grid>
            </Grid>

            <Grid container p={2} spacing={2}>
              {/* Address Type */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Address Type*</h5>
                {addressTypes?.length &&
                  <Select
                    className='c-text-field-4'
                    {...methods.register('type')}
                    disableUnderline
                    required
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          border: "1.5px solid #e9ecf1",
                          boxShadow: 'none',
                          borderRadius: '5px'
                        }
                      }
                    }}
                    variant='outlined'
                    sx={{
                      width: '100%',
                      boxShadow: "none",
                      paddingTop: '0px !important',
                      borderRadius: '7px !important',
                      marginTop: '4px',
                      '& .MuiOutlinedInput-input': { p: 0.7 },
                      marginBottom: '3px',
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: 0 },
                    }}
                    value={addressType ? addressType : ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("type", event.target.value, { shouldValidate: true });
                      setAddressType(event.target.value);
                    }}
                  >
                    {addressTypes && addressTypes.map((option) =>
                      <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                    )}
                  </Select>
                }
                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.type?.message ?? ""}</p>
              </Grid>

              {/* Office/Branch Name */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Title/Office/Branch Name</h5>
                <TextField
                  placeholder='e.g. Head Office'
                  {...methods.register('title')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>

              {/* Country */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Country*</h5>
                {countryOptions?.length &&
                  <Select
                    className='c-text-field-4'
                    {...methods.register('country')}
                    disableUnderline
                    required
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          border: "1.5px solid #e9ecf1",
                          boxShadow: 'none',
                          borderRadius: '5px'
                        }
                      }
                    }}
                    variant='outlined'
                    sx={{
                      width: '100%',
                      boxShadow: "none",
                      paddingTop: '0px !important',
                      borderRadius: '7px !important',
                      marginTop: '4px',
                      '& .MuiOutlinedInput-input': { p: 0.7 },
                      marginBottom: '3px',
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: 0 },
                    }}
                    value={addressCountry ? addressCountry : ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("country", event.target.value, { shouldValidate: true });
                      setAddressCountry(event.target.value);
                    }}
                  >
                    {countryOptions && countryOptions.map((option) =>
                      <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                    )}
                  </Select>
                }
                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.country?.message ?? ""}</p>
              </Grid>

              {/* State */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>State*</h5>
                {stateOptions?.length &&
                  <Select
                    className='c-text-field-4'
                    {...methods.register('state')}
                    disableUnderline
                    required
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          border: "1.5px solid #e9ecf1",
                          boxShadow: 'none',
                          borderRadius: '5px'
                        }
                      }
                    }}
                    variant='outlined'
                    sx={{
                      width: '100%',
                      boxShadow: "none",
                      paddingTop: '0px !important',
                      borderRadius: '7px !important',
                      marginTop: '4px',
                      '& .MuiOutlinedInput-input': { p: 0.7 },
                      marginBottom: '3px',
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { border: 0 },
                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: 0 },
                    }}
                    value={addressState ? addressState : ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("state", event.target.value, { shouldValidate: true });
                      setAddressState(event.target.value);
                    }}
                  >
                    {stateOptions && stateOptions.map((option) =>
                      <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                    )}
                  </Select>
                }
                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.state?.message ?? ""}</p>
              </Grid>

              {/* City */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>City*</h5>
                <TextField
                  placeholder='City'
                  {...methods.register('city')}
                  required
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.city?.message ?? ""}</p>
              </Grid>

              {/* Line 1 */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Address Line 1</h5>
                <TextField
                  placeholder='Address Line 1'
                  {...methods.register('line1')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Line 2 */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Address Line 2</h5>
                <TextField
                  placeholder='Address Line 2'
                  {...methods.register('line2')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Line 3 */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Address Line 3</h5>
                <TextField
                  placeholder='Address Line 3'
                  {...methods.register('line3')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Pincode */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Pincode</h5>
                <TextField
                  placeholder='Pincode'
                  {...methods.register('code')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Phone 1 */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Phone 1</h5>
                <TextField
                  placeholder='Phone 1'
                  {...methods.register('phone1')}
                  size='small'
                  type="number"
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Phone 2 */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Phone 2</h5>
                <TextField
                  placeholder='Phone 2'
                  {...methods.register('phone2')}
                  size='small'
                  type="number"
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </Grid>

              {/* Radius */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Radius (meters)</h5>
                <TextField
                  placeholder='e.g. 100'
                  type='number'
                  {...methods.register('radius')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{ disableUnderline: true, inputProps: { min: 0, step: 'any' } }}
                />
              </Grid>

              {/* Latitude */}
              <Grid item xs={6} pr={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Latitude</h5>
                <TextField
                  placeholder='e.g. 28.6139'
                  type='number'
                  {...methods.register('latitude')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{ disableUnderline: true, inputProps: { step: 'any' } }}
                />
              </Grid>

              {/* Longitude */}
              <Grid item xs={6} pl={1}>
                <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 14 }}>Longitude</h5>
                <TextField
                  placeholder='e.g. 77.2090'
                  type='number'
                  {...methods.register('longitude')}
                  size='small'
                  className='c-text-field-4'
                  variant="standard"
                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                  InputProps={{ disableUnderline: true, inputProps: { step: 'any' } }}
                />
              </Grid>
            </Grid>
          </Box>
        }
      </FormProvider>
    </Modal>
  );
};

export default DialogAddressForm;
